<template>
  <div>

    <m-row>
      <m-col lg="6" class="mb-4 mb-lg-0 pr-lg-4">
        <memlist-text-input
          id="filter-input"
          name="filter-input"
          layout="vertical"
          size="md"
          :placeholder="$t('SHOP_ITEM.SEARCH_NAME')"
          v-model="text_search"
        />
      </m-col>

      <m-col lg="6" class="mb-4 mb-lg-0 pl-lg-4">
        <Multiselect
          style="height: 56px;"
          class="multiselect-blue"
          v-model="company_ids"
          ref="company_multiselect"
          mode="tags"
          :placeholder="$t('SHOP_ITEM.SELECT_COMPANY_IDS')"
          :close-on-select="false"
          @input="companies_changed"
          :options="company_options"
        />
      </m-col>

    </m-row>

    <m-row>
      <m-col lg="6">
        <memlist-checkbox 
          text="Endast aktiva"
          v-model="active_only"
        />
        <memlist-checkbox 
          text="Endast medlemskap"
          v-model="memberships_only"
        />
      </m-col>
    </m-row>

    <memlist-static-table
      id="shop-items-table"
      style="width: 100%; table-layout: fixed;"
      class="table-striped mt-4"
      :fields="shop_item_headers"
      :items="shop_items"
      head-variant="light"
      ref="shop-items-table"
    >
      <template #cell(actions)="data">

        <div class='d-flex justify-content-end'>
          <memlist-table-button class="mr-2" @click="edit_shop_item_clicked(data.item)" svg="/assets/svg/pencil-square.svg" :tooltip="$t('COMMON.EDIT')" />
          <memlist-button class="mr-2" @click="item_selected_clicked(data.item)">Välj</memlist-button>
        </div>
      </template>

    </memlist-static-table>

  </div>

</template>

<script>
import { get_base_url, downloadWithAxios } from '@/core/services/fileDownload';
import Multiselect from '@vueform/multiselect/dist/multiselect.vue2.js'
import axios from 'axios';
import dayjs from 'dayjs';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { mapGetters } from 'vuex';


export default {
  name: 'ShopItemsAllCompaniesTable',
  props: [],
  components: {
    Multiselect,
  },
  emits: ['selected'],

  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'companies', 'settings', 'periods']),
    company_options() {
      return this.companies.map(i => ({ label: i.name, value: i.id }));
    }
  },
  mixins: [ toasts ],
  watch: {
    
    text_search() {
      this.load_shop_items();
    },

    active_only() {
      this.load_shop_items();
    },

    memberships_only() {
      this.load_shop_items();
    },

    company_ids: {
      deep: true,
      handler(val) {
        
        this.load_shop_items();
        
      },
      immediate: true
    },
    
  },
  data() {
    return {
      memberships_only: false,
      active_only: false,
      text_search: null,
      company_ids: [],
      shop_items: [],
      shop_item_headers: [
        {
          key: 'name',
          label: this.$t('SHOP_ITEM.NAME'),
          sortable: true,
          thClass: 'td-overflow',
          tdClass: 'td-overflow',
          
        },
        {
          key: 'company',
          label: this.$t('COMPANY.NAME'),
          thClass: 'td-short5',
          tdClass: 'td-short5',
          formatter: (_, __, item) => {
            return item.company.name;
          },
        },
        
        {
          key: 'period_type',
          label: this.$t('SHOP_ITEM.ITEM_PERIODS'),
          thClass: 'td-short5',
          tdClass: 'td-short5',
          formatter: (_, __, item) => {

            if (item.period_type === 'DAYS') {
              return item.num_days + ' dagar';
            }

            if (item.period_type === 'RANGE') {
              return item.from_date + ' - ' + item.to_date;
            }
            
            if (item.period_type === 'PERIODS') {
              // Find and return the names of the periods based on 'period_ids'
              const periodNames = item.period_ids.map(periodId => {
                // Look for the period by id within the periods prop
                const period = this.periods.find(p => p.id === periodId);
                
                // Return the name of the period if found, else return a default value or empty string
                return period ? period.name : '?';
              });
              
              return periodNames.join(',');  // Return the array of period names
            }
            
            return '-';
          },
        },
        {
          key: 'amount',
          label: this.$t('SHOP_ITEM.AMOUNT'),
          thClass: 'td-short3',
          tdClass: 'td-short3',
          sortable: false
        },
        
        {
          key: 'actions',
          tdClass: 'td-short4',
          thClass: 'td-short4',
          label: this.$t('COMMON.ACTIONS')
        }
      ],
      
      local_item: {}
    }
  },
  methods: {
    item_selected_clicked(item) {
      this.$emit('selected', item);
    },

    edit_shop_item_clicked(item) {},

    companies_changed(company_ids) {
      console.log('companies_changed', company_ids);
    },
    
    get_filters_string() {
      let url_filters = '';

      if (this.company_ids && this.company_ids.length > 0) {
        url_filters += `&company_ids=${encodeURIComponent('[' + this.company_ids.map(x => `"${x}"`).join(',') + ']')}`;
      }

      if (this.text_search) {
        url_filters += `&text=${encodeURIComponent(this.text_search)}`
      }

      if (this.active_only) {
        url_filters += `&active_only=true`
      }

      if (this.memberships_only) {
        url_filters += `&memberships_only=true`
      }

      return url_filters;
    },

    async load_shop_items() {
      const res = await axios.get(`/shop_item/search?${this.get_filters_string()}`);

      if (res.status === 200) {
        this.shop_items = res.data;
      }
    },
  }
}
</script>
<style scoped>
.empty-participant-message {
  text-align: center;
  padding: 4rem 1rem;
  background: #f9f9f9;
  border: 1px dashed #ccc;
  border-radius: 8px;
}

.big-icon {
  font-size: 4rem;
  color: #2D9BF0;
  margin-bottom: 1rem;
}

.info-text {
  font-size: 1.2rem;
  color: #555;
}
</style>